import React, { useState } from "react";
import { formatPrice } from "constants/massages";
import ReferralBookings from "scenes/konto/ReferralBookings";

const ReferralTab = ({ user }) => {
  const [copied, setCopied] = useState(false);
  const copyLink = async () => {
    if (!user?.referralLink) return;
    try {
      await navigator.clipboard.writeText(user.referralLink);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div role="tabpanel" aria-label="Empfehlungen" className="employee-referrals">
      <section className="konto-referral-card">
        <div className="konto-referral-head">
          <h2>Freunde empfehlen</h2>
          <p>Teile deinen Link. Nach der ersten bezahlten Massage erhalten du und der geworbene Kunde jeweils 5 € Massageguthaben.</p>
        </div>
        <div className="konto-referral-stats">
          <div>
            <span className="konto-referral-label">Massageguthaben</span>
            <strong>{formatPrice(user?.referralBalanceCents || 0)}</strong>
          </div>
          <div>
            <span className="konto-referral-label">Registrierungen</span>
            <strong>{user?.referralUseCount || 0}</strong>
          </div>
        </div>
        <div className="konto-referral-link-row">
          <input type="text" readOnly value={user?.referralLink || ""} aria-label="Dein Empfehlungslink" />
          <button type="button" className="btn-primary" onClick={copyLink} disabled={!user?.referralLink}>
            {copied ? "Kopiert" : "Link kopieren"}
          </button>
        </div>
      </section>
      <ReferralBookings />
    </div>
  );
};

export default ReferralTab;
